import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./videoLessons.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import VideoLessionsForm from "./videoLessonsForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";

import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";

// Redux slices
import { listVideoUpload } from "../../Redux/Slices/VideoUpload/ListVideoUploadSlice";
import { clearAddVideoUploadResponse } from "../../Redux/Slices/VideoUpload/AddVideoUploadSlice";
import { clearEditVideoUploadResponse } from "../../Redux/Slices/VideoUpload/EditVideoUploadSlice";
import {
  clearDeleteVideoUploadResponse,
  deleteVideoUpload,
} from "../../Redux/Slices/VideoUpload/DeleteVideoUploadSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";

interface VideoLessonsProps {}

const VideoLessons: FunctionComponent<VideoLessonsProps> = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<any>({ status: true });

  const dispatch = useAppDispatch();

  const { data: videoLessons } = useAppSelector(
    (state) => state.ListVideoUploadSliceReducer
  );
  const { data: addResponse } = useAppSelector(
    (state) => state.AddVideoUploadSlice
  );
  const { data: editResponse } = useAppSelector(
    (state) => state.EditVideoUploadSliceReducer
  );
  const { data: deleteResponse } = useAppSelector(
    (state) => state.DeleteVideoUploadSliceReducer
  );
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "masters";
  const filteredList = userPermissionlist.Dashboard?.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList?.[0]?.items;
  const finaldata = fliterdata?.[0];

  const formRef = useRef<HTMLFormElement>(null);

  const columns: Columns = [
    { field: "index", renderHeader: () => <b>S.No</b>, width: 90 },
    { field: "title", renderHeader: () => <b>Title</b>, flex: 1 },
    { field: "language", renderHeader: () => <b>Language</b>, flex: 1 },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      valueFormatter: (params) => (params.value ? "Active" : "Inactive"),
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <>
          <IconButtonField
            disabled={finaldata?.permissions?.edit === false}
            onClick={() => {
              setInitialValues(params.row);
              setDialogOpen(true);
            }}
          >
            <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
          </IconButtonField>
          <IconButtonField
            disabled={finaldata?.permissions?.delete === false}
            onClick={() => {
              setDeleteData({ id: params.id, name: params.row.title });
              setDeleteDialogOpen(true);
            }}
          >
            <SvgIcon component={Delete} inheritViewBox />
          </IconButtonField>
        </>
      ),
    },
  ];

  const rows = (videoLessons?.data ?? []).map((item: any, index: number) => ({
    ...item,
    index: index + 1,
  }));

  useEffect(() => {
    console.log("Dispatching listVideoUpload");
    dispatch(listVideoUpload());
    // dispatch(listSideMenuPermission());
  }, [addResponse, editResponse, deleteResponse]);

  useEffect(() => {
    return () => {
      dispatch(clearAddVideoUploadResponse());
      dispatch(clearEditVideoUploadResponse());
      dispatch(clearDeleteVideoUploadResponse());
    };
  }, []);

  return (
    <>
      <Table rows={rows} columns={columns}>
        <CustomToolbar>
          {/* <h6>Video Lessons</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add Video
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listVideoUpload())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${initialValues?.id ? "Edit" : "Add"} Video`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <VideoLessionsForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog response={addResponse} parentDialog={setDialogOpen} />
      <ResponseDialog response={editResponse} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          console.log("delete called");
          dispatch(deleteVideoUpload(String(deleteData.id)));
        }}
        response={deleteResponse}
      />
    </>
  );
};

export default VideoLessons;
